import script from "./FormElMsg.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormElMsg.vue?vue&type=script&setup=true&lang=ts"

import "./FormElMsg.vue?vue&type=style&index=0&id=14891c86&lang=scss"

const __exports__ = script;

export default __exports__